import React, { useEffect, useState } from "react";
const TotalBarTow = ({ chartData }) => {
  const [sumData, setSumData] = useState(null);
  function getTotalChartData(chartData) {
    if (!chartData || !Array.isArray(chartData.series)) return null;

    // Auto-detect numeric keys from dimensions (excluding 'product')
    const keysToSum = chartData.dimensions.filter((key) => key !== "product");

    const totalEntry = { product: "Total" };

    keysToSum.forEach((key) => {
      totalEntry[key] = chartData.series
        .reduce((sum, item) => {
          const val = parseFloat(item[key]);
          return sum + (isNaN(val) ? 0 : val);
        }, 0)
        .toFixed(2); // rounded to 2 decimal places
    });

    return {
      dimensions: chartData.dimensions,
      series: [totalEntry],
    };
  }

  const stackedChartData = (data) => {
    let tempDimensions = data.dimensions;
    tempDimensions.splice(0, 1);
    let tempSeries = [];
  };
  useEffect(() => {
    if (chartData) {
      const sd = getTotalChartData(chartData);
      setSumData(sd);
    }
  }, [chartData]);
  useEffect(() => {
    if (sumData) {
      stackedChartData(sumData);
    }
  }, [sumData]);
  // console.log(sumData);
  return <div>Total bar</div>;
};
export default TotalBarTow;
